import React from 'react';
import { motion } from 'framer-motion';
import { Quote, Star } from 'lucide-react';
const data = [['VT', 'Valeria T.', 'Docente de Historia | Lima, Perú', 'El material sobre el siglo XX le cambió la cara a mis alumnos. Por fin entienden los conflictos mundiales sin perderse entre tantos datos.'], ['CR', 'Carlos R.', 'Profesor de Historia | Montevideo, Uruguay', 'El banco de evaluaciones vale por sí solo el precio del pack. Nunca más construí un examen desde cero bajo presión.'], ['DG', 'Daniel G.', 'Docente de Historia | Caracas, Venezuela', 'Las líneas del tiempo del bono 4 transformaron el grupo más difícil que tenía. Ahora todos saben ubicarse en el tiempo sin esfuerzo.'], ['AM', 'Ana M.', 'Docente de nivel medio | Buenos Aires, Argentina', 'El glosario me devolvió el tiempo de clase. Ahora podemos ir directo al contenido sin detenernos a definir cada término.'], ['SR', 'Sebastián R.', 'Profesor de Historia | Quito, Ecuador', 'El manual de preguntas difíciles cambió completamente mi seguridad en el aula. Ahora espero las preguntas complejas en lugar de temerlas.']];
export function ExtendedTestimonials() {
  return <section className="bg-dark-card px-4 py-20" data-id="element-49">
      <div className="mx-auto max-w-6xl" data-id="element-50">
        <h2 className="mb-14 text-center font-serif text-3xl font-bold sm:text-5xl" data-id="element-51">
          Lo que dicen los docentes que ya tienen su Mega Pack
        </h2>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-52">
          {data.map(([initials, name, role, text], i) => <motion.article initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} key={name} className="relative rounded-2xl border border-dark-border bg-black p-7" data-id="element-53">
              <Quote className="absolute right-5 top-5 text-gold/10" size={44} data-id="element-54" />
              <div className="mb-5 flex text-gold" data-id="element-55">
                {Array.from({
              length: 5
            }, (_, j) => <Star key={j} size={15} fill="currentColor" data-id="element-56" />)}
              </div>
              <p className="mb-7 text-sm italic leading-relaxed text-gray-300" data-id="element-57">
                “{text}”
              </p>
              <div className="flex items-center gap-3" data-id="element-58">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-gold-gradient font-bold text-black" data-id="element-59">
                  {initials}
                </span>
                <div data-id="element-60">
                  <strong className="block text-sm" data-id="element-61">{name}</strong>
                  <span className="text-xs text-gold-light" data-id="element-62">{role}</span>
                </div>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}